import { ApiServiceBase } from './ApiServiceBase'

export default class extends ApiServiceBase {
  async store(): Promise<any> {
    return await this.call('/spa/extension-token', {
      method: 'post',
    })
  }
}
